import { useEffect, useState } from 'react';
import { request } from '~/components/Instance';
import { setStagesConfig } from '~/_domains/societario/helpers';

// Etapas que o escritório configurou, carregadas uma vez por sessão e
// compartilhadas entre o painel, os cards e o ticket. Quem usa o hook
// re-renderiza quando a lista chega ou muda em Configurações.
let pending = null;
let version = 0;
const listeners = [];

export const applyStagesOverview = (overview) => {
  setStagesConfig(overview && overview.categories);
  version += 1;
  listeners.slice().forEach((listener) => listener(version));
};

export const loadSocietarioStages = (force) => {
  if (pending && !force) {
    return pending;
  }

  pending = request('get', '/societario/stages', {}, false)
    .then((response) => {
      const overview = response.data && response.data.data;
      applyStagesOverview(overview);
      return overview;
    })
    .catch(() => {
      // Sem a configuração, valem as listas padrão; tenta de novo na próxima.
      pending = null;
      return null;
    });

  return pending;
};

export const useSocietarioStages = () => {
  const [current, setCurrent] = useState(version);

  useEffect(() => {
    listeners.push(setCurrent);
    loadSocietarioStages();

    return () => {
      const index = listeners.indexOf(setCurrent);
      if (index !== -1) listeners.splice(index, 1);
    };
  }, []);

  return current;
};
